
import { ShippingMethodType } from '../../state/CartContext';
import { APP_CONFIG } from '../constants';

export interface ShippingOption {
    id: ShippingMethodType;
    name: string;
    price: number; // Base price before rules
    eta: string;
    requiresAddress: boolean;
}

export const shippingService = {
    /**
     * Determines available shipping methods based on Zip Code.
     * Simulates a backend logistics engine.
     */
    getOptionsForZip(zipCode: string, baseCosts: { local: number, national: number }): ShippingOption[] {
        const numericZip = parseInt(zipCode);
        if (isNaN(numericZip)) return [];

        // Logic: Use centralized constants
        const isLocal = numericZip >= APP_CONFIG.LOGISTICS.LOCAL_ZIP_START && numericZip <= APP_CONFIG.LOGISTICS.LOCAL_ZIP_END;

        if (isLocal) {
            return [
                { 
                    id: 'local', 
                    name: 'Envío Local (Moto)', 
                    price: baseCosts.local, 
                    eta: '24hs',
                    requiresAddress: true 
                },
                { 
                    id: 'pickup', 
                    name: 'Retiro en Local', 
                    price: 0, 
                    eta: 'Inmediato',
                    requiresAddress: false
                }
            ];
        } else {
            return [
                { 
                    id: 'national', 
                    name: 'Envío Nacional (Correo)', 
                    price: baseCosts.national, 
                    eta: '3-5 días',
                    requiresAddress: true
                }
            ];
        }
    },

    /**
     * Calculates the final shipping cost applying free shipping rules.
     */
    calculateFinalCost(
        methodId: ShippingMethodType, 
        basePrice: number, 
        rules: { 
            isFreeByAmount: boolean, 
            isFreeByReward: boolean, 
            isFreeByCoupon: boolean,
            isFreeByCategory: boolean
        }
    ): number {
        if (methodId === 'pickup') return 0;
        
        // If any free shipping rule is met, cost is 0
        if (rules.isFreeByAmount || rules.isFreeByReward || rules.isFreeByCoupon || rules.isFreeByCategory) {
            return 0;
        }

        return basePrice;
    }
};
